import _Object$defineProperty from "@babel/runtime-corejs2/core-js/object/define-property";
import _Object$defineProperties from "@babel/runtime-corejs2/core-js/object/define-properties";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs2/core-js/object/get-own-property-descriptors";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs2/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs2/core-js/object/get-own-property-symbols";
import _Object$keys from "@babel/runtime-corejs2/core-js/object/keys";
import "core-js/modules/es6.regexp.match";
import "core-js/modules/es6.regexp.replace";
import "core-js/modules/es6.string.starts-with";
import _extends from "@babel/runtime-corejs2/helpers/extends";
import _classCallCheck from "@babel/runtime-corejs2/helpers/classCallCheck";
import _createClass from "@babel/runtime-corejs2/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime-corejs2/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime-corejs2/helpers/getPrototypeOf";
import _inherits from "@babel/runtime-corejs2/helpers/inherits";
import _defineProperty from "@babel/runtime-corejs2/helpers/defineProperty";

var _dec, _dec2, _class, _class2, _temp;

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { PureComponent } from 'react';
import types from 'prop-types';
import { push, replace, match as _match, parseRouteToUrl, parseUrlToRoute } from '@rexlabs/whereabouts';
import { autobind } from 'core-decorators';
import { withWhereabouts } from './connectors';
import invariant from 'invariant';
import { styled, StyleSheet } from '@rexlabs/styling';
/**
 * Checks if an event should be treated as a "new tab" or "new window" click.
 * @returns {Boolean}
 */

function isClickSignallingUserAgentBehaviours(event, parentRef) {
  return event.target && (event.target.nodeName === 'A' || parentRef && parentRef.contains(event.target)) && (event.metaKey || event.ctrlKey || event.shiftKey);
}

function isClickAnchorWithTarget(event) {
  return event.target && event.target.nodeName === 'A' && !!event.target.getAttribute('target');
}

var Link = (_dec = withWhereabouts(), _dec2 = styled(StyleSheet({
  anchor: {}
})), _dec(_class = _dec2(_class = autobind(_class = (_temp = _class2 =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Link, _PureComponent);

  function Link() {
    var _this;

    _classCallCheck(this, Link);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Link).call(this));
    _this.anchorRef = null;

    _this.setAnchorRef = function (element) {
      _this.anchorRef = element;
    };

    _this.DefaultLinkComponent = function (_ref) {
      var onClick = _ref.onClick,
          target = _ref.target,
          active = _ref.active,
          className = _ref.className,
          setRef = _ref.setRef,
          s = _ref.styles;
      var cn = [className, active && 'active'].filter(Boolean).join(' ');
      return React.createElement("a", _extends({}, s('anchor'), {
        ref: setRef,
        href: target,
        onClick: onClick,
        className: cn
      }), _this.props.children);
    };

    return _this;
  }

  _createClass(Link, [{
    key: "getTo",
    value: function getTo() {
      return typeof this.props.to === 'string' ? {
        config: parseUrlToRoute(this.props.to)
      } : this.props.to;
    } // Build routes object considering precedence of detailed props
    // over optionally given `to` prop

  }, {
    key: "getRouteObjectFromProps",
    value: function getRouteObjectFromProps() {
      var _this$props = this.props,
          path = _this$props.path,
          hash = _this$props.hash,
          whereabouts = _this$props.whereabouts;
      var to = this.getTo();
      var finalPath = null;
      var finalHash = null;
      var configPath = to && to.config ? to.config.path : null;
      var configHash = to && to.config ? to.config.hash : null; // Check path and hash for leading wildcard and replace it with
      // either given prop or current location values

      if (configPath && configPath.startsWith('(.*)')) {
        var oldPath = configPath;
        var newPath = path || whereabouts.path;
        newPath += oldPath.substr(4, oldPath.length);
        finalPath = newPath;
      }

      if (configHash && configHash.startsWith('(.*)')) {
        var oldHash = configHash;
        var newHash = hash || whereabouts.hash || '';
        newHash += oldHash.substr(4, oldHash.length);
        finalHash = newHash;
      } // Fallback to path prop or current path


      if (!finalPath) {
        finalPath = path || configPath || whereabouts.path;
      } // We don't want to carry through hashes, so just fall back to
      // the hash prop


      if (!finalHash) {
        finalHash = hash || configHash;
      }

      return {
        config: _objectSpread({}, to && to.config ? to.config : {}, {
          path: finalPath,
          hash: finalHash,
          query: this.resolveQuery()
        })
      };
    } // Resolve query (which could be a function) to valid query object

  }, {
    key: "resolveQuery",
    value: function resolveQuery() {
      var _this$props2 = this.props,
          query = _this$props2.query,
          keepQuery = _this$props2.keepQuery,
          whereabouts = _this$props2.whereabouts;
      var to = this.getTo(); // Optionally keep the current query object
      // You can set this option on the link component or on the route, e.g.
      // useful for modal where you always want to keep query params around!

      if (keepQuery || to && to.config && to.config.keepQuery) {
        return whereabouts.query;
      }

      var finalQuery = query || (to && to.config ? to.config.query : {});

      if (typeof finalQuery === 'function') {
        finalQuery = finalQuery(whereabouts.query);
      }

      return finalQuery;
    } // Handle click by preventing default and using history function depending
    // on given props

  }, {
    key: "onLinkClick",
    value: function onLinkClick(e) {
      var _this$props3 = this.props,
          ignoreModifierKeys = _this$props3.ignoreModifierKeys,
          ignoreTargetted = _this$props3.ignoreTargetted,
          params = _this$props3.params,
          state = _this$props3.state,
          useReplace = _this$props3.replace; // ...unless the click is a new tab / new window behaviour

      if (ignoreModifierKeys && isClickSignallingUserAgentBehaviours(e, this.anchorRef)) {
        return;
      }

      if (ignoreTargetted && isClickAnchorWithTarget(e)) return;
      e.preventDefault();
      var route = this.getRouteObjectFromProps();
      var options = {};
      if (params) options.params = params;
      if (state) options.state = state;

      if (useReplace) {
        replace(route, options);
      } else {
        push(route, options);
      }
    } // Matches the given `activeMatches` against the current location received
    // from `withWhereabouts`

  }, {
    key: "match",
    value: function match() {
      var _this$props4 = this.props,
          activeMatches = _this$props4.activeMatches,
          whereabouts = _this$props4.whereabouts;
      var matchMe = activeMatches;
      var to = this.getTo();

      if (matchMe === undefined && to) {
        matchMe = [to.config];
      }

      if (!matchMe) {
        return false;
      }

      var matched = false;
      matchMe.forEach(function (route) {
        if (typeof route === 'string') {
          route = {
            path: route
          };
        }

        if (_match(whereabouts, route, {
          exact: route.exact
        })) {
          matched = true;
          return false;
        }
      });
      return matched;
    } // Build url string from given props

  }, {
    key: "buildUrl",
    value: function buildUrl() {
      var _this$props$params = this.props.params,
          params = _this$props$params === void 0 ? {} : _this$props$params;
      var route = this.getRouteObjectFromProps() || {};
      return parseRouteToUrl(_objectSpread({}, route.config, {
        params: params
      }));
    } // On component mount we want to do some validations, as well as run prefetch functionality
    // if requested and available!

  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props5 = this.props,
          prefetch = _this$props5.prefetch,
          to = _this$props5.to,
          _this$props5$params = _this$props5.params,
          params = _this$props5$params === void 0 ? {} : _this$props5$params;

      if (prefetch) {
        invariant(to && to.config, 'You need to define a route config in the \'to\' prop in order to use the prefetch functionality!');
        invariant(typeof to.config.prefetch === 'function', 'You requested prefetch in this <Link />, but the given route does not have a prefetch function defined!');
        to.config.prefetch(params);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props6 = this.props,
          whereabouts = _this$props6.whereabouts,
          children = _this$props6.children,
          className = _this$props6.className,
          styles = _this$props6.styles;
      var props = {
        target: this.buildUrl(),
        onClick: this.onLinkClick,
        active: this.match(),
        whereabouts: whereabouts,
        setRef: this.setAnchorRef,
        className: className,
        styles: styles
      }; // If children is not a function, create a link tag as default fallback

      if (typeof children === 'function') {
        return children(props);
      } else {
        var DefaultLinkComponent = this.DefaultLinkComponent;
        return React.createElement(DefaultLinkComponent, props);
      }
    }
  }]);

  return Link;
}(PureComponent), _defineProperty(_class2, "defaultProps", {
  ignoreModifierKeys: true,
  ignoreTargetted: true
}), _temp)) || _class) || _class) || _class);
Link.propTypes = process.env.NODE_ENV !== "production" ? {
  to: types.oneOfType([types.object, types.string]),
  params: types.object,
  state: types.object,
  path: types.string,
  query: types.oneOfType([types.func, types.object]),
  hash: types.string,
  activeMatches: types.arrayOf(types.oneOfType([types.string, types.object])),
  prefetch: types.bool,
  replace: types.bool,
  children: types.oneOfType([types.element, types.string, types.func]),
  ignoreModifierKeys: types.bool,
  ignoreTargetted: types.bool
} : {};
export default Link;